import { NEW_LINE } from '~/constants'
import { ECampaignKeys } from '~/features/campaigns/models'

export const legacyRulesToText = (rules?: string[] | null): string => {
  if (!Array.isArray(rules) || rules.length === 0) {
    return ''
  }

  return rules
    .map((rule) => String(rule).trim())
    .filter(Boolean)
    .map((rule) => `- ${rule}`)
    .join(NEW_LINE)
}

export const normalizeOutreachInstructionsText = (text: string): string =>
  text.replace(/\r\n/g, '\n').replace(/\r/g, '\n')

export const getOutreachInstructionsDisplayText = (campaign: {
  outreachInstructionsText?: string | null
  rules?: string[] | null
}): string => {
  if (campaign.outreachInstructionsText != null) {
    const trimmed = campaign.outreachInstructionsText.trim()
    return trimmed ? normalizeOutreachInstructionsText(trimmed) : ''
  }

  return legacyRulesToText(campaign.rules)
}

export const getOutreachInstructionsSaveFields = (
  text: string | null | undefined,
): {
  [ECampaignKeys.outreachInstructionsText]: string | null
  [ECampaignKeys.rules]: []
} => {
  if (text == null) {
    return {
      [ECampaignKeys.outreachInstructionsText]: null,
      [ECampaignKeys.rules]: [],
    }
  }

  const trimmed = normalizeOutreachInstructionsText(text).trim()

  return {
    [ECampaignKeys.outreachInstructionsText]: trimmed || null,
    [ECampaignKeys.rules]: [],
  }
}
